import { FunctionComponent } from 'react';
import SlideShow from '../SlideShow/SlideShow';
import ELinx from './DynamicPreviews/ELinx';
import ELinxVerify from './DynamicPreviews/ELinxVerify';
import Email from './DynamicPreviews/Email';
import Onboarding from './DynamicPreviews/Onboarding';
import Portal from './DynamicPreviews/Portal';

export type PreviewProps = {
  preview: 'elinx' | 'email' | 'onboarding' | 'portal' | 'crossborder';
  primaryColor: string;
  secondaryColor: string;
  logo: string;
  width: number;
  height: number;
  slideShow: boolean;
  onChangeIndex?: (index: number) => void;
};

type FC = FunctionComponent<PreviewProps>;

const Preview: FC = ({
  preview,
  height,
  width,
  primaryColor,
  secondaryColor,
  logo,
  slideShow = true,
  onChangeIndex = () => {},
}: PreviewProps) => (
  // display: contents keeps this div out of the layout tree so consumers can flex/grid-center the
  // preview content itself; data-testid stays queryable by Cypress since the DOM node is unaffected.
  <div data-testid="preview" style={{ display: 'contents' }}>
    {preview === 'elinx' && slideShow && (
      <SlideShow
        Content={[
          <ELinx
            height={height}
            width={width}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            logo={logo}
          />,
          <ELinxVerify
            height={height}
            width={width}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            logo={logo}
          />,
        ]}
        onChangeIndex={onChangeIndex}
        haveNoDots={false}
        padding="0px 0px 20px 0px"
      />
    )}
    {preview === 'elinx' && !slideShow && (
      <ELinx height={height} width={width} primaryColor={primaryColor} secondaryColor={secondaryColor} logo={logo} />
    )}
    {preview === 'email' && (
      <Email height={height} width={width} primaryColor={primaryColor} secondaryColor={secondaryColor} logo={logo} />
    )}
    {preview === 'onboarding' && (
      <Onboarding
        height={height}
        width={width}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        logo={logo}
      />
    )}
    {preview === 'portal' && (
      <Portal height={height} width={width} primaryColor={primaryColor} secondaryColor={secondaryColor} logo={logo} />
    )}
  </div>
);

export default Preview;
